import React from 'react';

interface IconProps {
  color?: string;
  onClick?: () => void;
}

export const BackArrowIcon: React.FC<IconProps> = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.666 16L20.888 22.222L19.111 24L11.111 16L19.111 8L20.889 9.778L14.666 16Z"
        fill="#6B7684"
      />
    </svg>
  );
};

export const BuildingIcon: React.FC = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25002 26.9167V8.07564C4.25002 7.47991 4.6227 6.94784 5.18256 6.74427L18.8829 1.76229C19.2505 1.6286 19.657 1.81826 19.7907 2.18592C19.8189 2.26351 19.8334 2.34543 19.8334 2.42798V9.44448L28.7813 12.4271C29.3599 12.62 29.75 13.1613 29.75 13.7711V26.9167H32.5834V29.75H1.41669V26.9167H4.25002ZM7.08335 26.9167H17V5.46184L7.08335 9.06791V26.9167ZM26.9167 26.9167V14.7923L19.8334 12.4311V26.9167H26.9167Z"
        fill="#D2D2D2"
      />
    </svg>
  );
};

export const HelmetIcon: React.FC = () => {
  return (
    <svg
      width="34"
      height="24"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.5765 17.4626C31.5059 12.884 30.3093 9.26395 28.0188 6.6997C26.2414 4.71 23.8058 3.35484 20.7773 2.66807L20.7507 2.45914C20.6457 1.62728 19.9338 1 19.0957 1H15.6207C14.7801 1 14.0682 1.62922 13.9647 2.46349L13.9386 2.67533C13.5657 2.73385 13.2518 2.78995 12.996 2.8359C12.8306 2.8654 12.6874 2.89103 12.5868 2.90651C10.2915 3.25763 8.325 4.27424 6.74157 5.92829C5.49136 7.23412 4.48249 8.93459 3.74348 10.9828C2.70704 13.8556 2.49763 16.5679 2.45603 17.4694C1.96127 17.8229 1.60096 18.1644 1.35962 18.5078C1.06605 18.9256 0.951432 19.3464 1.01866 19.7585C1.20292 20.8907 2.6698 21.3317 2.87487 21.3878C5.75011 22.2395 8.88699 22.8131 12.1985 23.0917C13.7761 23.2247 15.3958 23.291 17.0407 23.291C18.1545 23.291 19.2804 23.2605 20.4126 23.1996C25.0759 22.9481 28.2335 22.2724 28.5063 22.2124C29.9321 21.9677 30.9821 21.6577 31.7172 21.265C32.4499 20.8732 32.8736 20.3853 32.9761 19.8141C33.1715 18.7269 32.1196 17.8413 31.5755 17.4631L31.5765 17.4626ZM31.8144 19.6051C31.7878 19.7502 31.4942 20.5028 28.2945 21.0498C28.2848 21.0512 28.2751 21.0532 28.266 21.0556C28.234 21.0628 25.0115 21.7699 20.3251 22.0209C16.0134 22.2516 9.54329 22.1322 3.20519 20.2532C3.20036 20.2518 3.19745 20.2508 3.19262 20.2498C2.80861 20.1439 2.22921 19.8402 2.18568 19.5679C2.15183 19.3561 2.44007 18.8918 3.36383 18.279C3.52633 18.1711 3.62548 17.9893 3.62789 17.7944C3.62789 17.763 3.68255 14.6178 4.86601 11.3557C5.90826 8.48191 7.45494 6.43273 9.48284 5.22798L8.68483 9.56671C8.63308 9.84819 8.81928 10.1181 9.10028 10.1698C9.13171 10.1756 9.16364 10.1785 9.19459 10.1785C9.43979 10.1785 9.65743 10.0039 9.70338 9.75436L10.6165 4.79077C10.6247 4.74676 10.6262 4.70371 10.6233 4.66115C11.2936 4.38693 12.0084 4.19106 12.7668 4.07498C12.8823 4.05709 13.025 4.03194 13.2054 3.99953C13.3737 3.96955 13.5686 3.93424 13.7882 3.89749L12.5815 13.6472C12.5414 13.9707 12.7716 14.2658 13.0951 14.3059C13.4187 14.3456 13.7137 14.1158 13.7539 13.7923L15.1376 2.61004C15.1675 2.36628 15.3755 2.1825 15.6212 2.1825H19.0961C19.3409 2.1825 19.5488 2.3658 19.5793 2.60859L20.9925 13.7937C21.0302 14.0921 21.2846 14.3103 21.5777 14.3103C21.6024 14.3103 21.6275 14.3088 21.6527 14.3054C21.9762 14.2643 22.2055 13.9693 22.1644 13.6452L20.9359 3.92167C22.0613 4.20653 23.0871 4.59151 24.0133 5.07563L24.8781 9.77613C24.9303 10.061 25.1789 10.2598 25.4584 10.2598C25.4937 10.2598 25.53 10.2564 25.5658 10.2501C25.8864 10.1911 26.0988 9.88301 26.0398 9.56236L25.3665 5.90266C28.6887 8.26911 30.377 12.2466 30.3988 17.7891C30.3998 17.998 30.512 18.1919 30.6924 18.2974C31.2079 18.5987 31.8845 19.2211 31.8149 19.6056L31.8144 19.6051Z"
        fill="white"
        stroke="#D2D2D2"
        strokeWidth="0.8"
      />
      <path
        d="M26.3793 18.0497C22.0633 18.8458 17.2172 18.8037 13.9115 18.6277C10.3166 18.4366 7.71513 18.0502 7.68901 18.0463C7.36642 17.998 7.0656 18.2199 7.01724 18.5425C6.96887 18.8651 7.19086 19.1659 7.51345 19.2143C7.53957 19.2182 10.1865 19.6114 13.8346 19.8063C14.9949 19.8682 16.3418 19.9137 17.7908 19.9137C20.5533 19.9137 23.6849 19.7473 26.5935 19.2109C26.9142 19.1519 27.1265 18.8438 27.067 18.5232C27.008 18.2025 26.6994 17.9902 26.3793 18.0497Z"
        fill="white"
        stroke="#D2D2D2"
        strokeWidth="0.8"
      />
    </svg>
  );
};

export const AddIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#F3F3F3" />
      <path
        d="M11.3333 11.3333V7.33334H12.6667V11.3333H16.6667V12.6667H12.6667V16.6667H11.3333V12.6667H7.33333V11.3333H11.3333Z"
        fill="#437BE6"
      />
    </svg>
  );
};

export const DelIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"
        fill="black"
      />
    </svg>
  );
};

export const CheckIcon: React.FC = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="33" cy="33" r="33" fill="#437BE6" />
      <path
        d="M29.9996 37.7563L43.7882 23.9678L45.9095 26.0891L29.9996 41.9989L20.4536 32.4531L22.5749 30.3318L29.9996 37.7563Z"
        fill="white"
      />
    </svg>
  );
};

export const EyesIcon: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.412 14.4726C12.1361 15.2816 10.6229 15.7502 9.00023 15.7502C4.95609 15.7502 1.59161 12.8403 0.88623 9.00015C1.21374 7.21712 2.11449 5.63468 3.39035 4.45093L1.04525 2.10583L2.10591 1.04517L16.9552 15.8944L15.8945 16.9551L13.412 14.4726ZM4.4517 5.51228C3.45505 6.42012 2.72835 7.6254 2.41709 9.00015C3.10517 12.0391 5.82345 14.2502 9.00023 14.2502C10.1998 14.2502 11.334 13.9349 12.3182 13.3788L10.797 11.8576C10.2767 12.1854 9.6606 12.3752 9.00023 12.3752C7.13624 12.3752 5.6252 10.8641 5.6252 9.00015C5.6252 8.3397 5.81488 7.72358 6.14273 7.20332L4.4517 5.51228ZM9.68543 10.746L7.25435 8.31495C7.17098 8.5272 7.1252 8.75828 7.1252 9.00015C7.1252 10.0357 7.9647 10.8752 9.00023 10.8752C9.24203 10.8752 9.47318 10.8293 9.68543 10.746ZM15.6051 12.4444L14.532 11.3713C15.0239 10.6701 15.3865 9.86895 15.5833 9.00015C14.8952 5.96114 12.1769 3.75012 9.00023 3.75012C8.3658 3.75012 7.74968 3.8383 7.16437 4.00364L5.98085 2.82012C6.91595 2.4522 7.93448 2.25012 9.00023 2.25012C13.0443 2.25012 16.4088 5.15994 17.1142 9.00015C16.88 10.2749 16.3529 11.4471 15.6051 12.4444ZM8.79218 5.63143C8.86095 5.62725 8.93033 5.62512 9.00023 5.62512C10.8641 5.62512 12.3752 7.13616 12.3752 9.00015C12.3752 9.06998 12.3731 9.13935 12.3689 9.20813L8.79218 5.63143Z"
        fill="#D8D7DC"
      />
    </svg>
  );
};

export const BigCheckIcon: React.FC = () => {
  return (
    <svg
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="33" cy="33" r="33" fill="#437BE6" />
      <path
        d="M31.375 23.875H35.625V28.125H31.375V23.875ZM31.375 32.375H35.625V45.125H31.375V32.375Z"
        fill="white"
      />
    </svg>
  );
};

export const HomeIcon: React.FC = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 17.7327C18 17.9979 17.8946 18.2523 17.7071 18.4398C17.5196 18.6273 17.2652 18.7327 17 18.7327H1C0.734784 18.7327 0.48043 18.6273 0.292893 18.4398C0.105357 18.2523 0 17.9979 0 17.7327V7.22169C4.6588e-05 7.06948 0.0348423 6.91928 0.101735 6.78254C0.168628 6.64581 0.265853 6.52616 0.386 6.43269L8.386 0.210694C8.56154 0.0741392 8.7776 0 9 0C9.2224 0 9.43846 0.0741392 9.614 0.210694L17.614 6.43269C17.7341 6.52616 17.8314 6.64581 17.8983 6.78254C17.9652 6.91928 18 7.06948 18 7.22169V17.7327Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const SurveyIcon: React.FC = () => {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 2V6H15V2H17.007C17.2703 2.00026 17.5227 2.10497 17.7089 2.29114C17.895 2.4773 17.9997 2.72972 18 2.993V19.007C17.9997 19.2703 17.895 19.5227 17.7089 19.7089C17.5227 19.895 17.2703 19.9997 17.007 20H0.993C0.72964 20 0.477067 19.8954 0.290843 19.7092C0.104619 19.5229 0 19.2704 0 19.007V2.993C0.000264735 2.72972 0.104969 2.4773 0.291135 2.29114C0.477302 2.10497 0.729721 2.00026 0.993 2H3ZM6 15H4V17H6V15ZM6 12H4V14H6V12ZM6 9H4V11H6V9ZM13 0V4H5V0H13Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const ShoppingIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.28878 4.657L0.0507812 1.414L1.46478 0L4.70778 3.24H19.9488C20.1046 3.23999 20.2584 3.27641 20.3976 3.34637C20.5369 3.41632 20.6579 3.51786 20.751 3.6429C20.8441 3.76793 20.9066 3.91298 20.9337 4.06649C20.9607 4.21999 20.9515 4.37769 20.9068 4.527L18.5068 12.527C18.445 12.7331 18.3185 12.9138 18.1459 13.0422C17.9733 13.1707 17.7639 13.24 17.5488 13.24H5.28878V15.24H16.2888V17.24H4.28878C4.02356 17.24 3.76921 17.1346 3.58167 16.9471C3.39414 16.7596 3.28878 16.5052 3.28878 16.24V4.657ZM4.78878 21.24C4.49211 21.24 4.2021 21.152 3.95543 20.9872C3.70875 20.8224 3.51649 20.5881 3.40296 20.314C3.28943 20.0399 3.25973 19.7383 3.3176 19.4474C3.37548 19.1564 3.51834 18.8891 3.72812 18.6793C3.9379 18.4696 4.20517 18.3267 4.49615 18.2688C4.78712 18.2109 5.08872 18.2406 5.36281 18.3542C5.6369 18.4677 5.87116 18.66 6.03599 18.9066C6.20081 19.1533 6.28878 19.4433 6.28878 19.74C6.28878 20.1378 6.13075 20.5194 5.84944 20.8007C5.56814 21.082 5.18661 21.24 4.78878 21.24ZM16.7888 21.24C16.4921 21.24 16.2021 21.152 15.9554 20.9872C15.7088 20.8224 15.5165 20.5881 15.403 20.314C15.2894 20.0399 15.2597 19.7383 15.3176 19.4474C15.3755 19.1564 15.5183 18.8891 15.7281 18.6793C15.9379 18.4696 16.2052 18.3267 16.4961 18.2688C16.7871 18.2109 17.0887 18.2406 17.3628 18.3542C17.6369 18.4677 17.8712 18.66 18.036 18.9066C18.2008 19.1533 18.2888 19.4433 18.2888 19.74C18.2888 20.1378 18.1307 20.5194 17.8494 20.8007C17.5681 21.082 17.1866 21.24 16.7888 21.24Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const DraftIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 0C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V4.757L9 13.757L8.995 18H13.241L18 13.242V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17ZM18.778 6.808L20.192 8.222L12.414 16H11V14.588L18.778 6.808ZM9 10H4V12H9V10ZM12 6H4V8H12V6Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const MegaphoneIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.199 7.563V1.5C18.199 1.23478 18.0936 0.98043 17.9061 0.792893C17.7185 0.605357 17.4642 0.5 17.199 0.5H16.199C14.22 2.479 10.499 3.587 8.19897 4.113V14.887C10.499 15.413 14.22 16.521 16.199 18.5H17.199C17.4642 18.5 17.7185 18.3946 17.9061 18.2071C18.0936 18.0196 18.199 17.7652 18.199 17.5V11.437C18.6287 11.3265 19.0095 11.0762 19.2815 10.7255C19.5534 10.3749 19.7009 9.94374 19.7009 9.5C19.7009 9.05626 19.5534 8.62512 19.2815 8.27445C19.0095 7.92378 18.6287 7.6735 18.199 7.563ZM2.19897 4.5C1.66854 4.5 1.15983 4.71071 0.784761 5.08579C0.409688 5.46086 0.198975 5.96957 0.198975 6.5V12.5C0.198975 13.0304 0.409688 13.5391 0.784761 13.9142C1.15983 14.2893 1.66854 14.5 2.19897 14.5H3.19897L4.19897 19.5H6.19897V4.5H2.19897Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const AlertIcon: React.FC = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 27.1998H12V25.3998H12.9V19.1278C12.9 18.0641 13.1095 17.0108 13.5166 16.0281C13.9236 15.0454 14.5203 14.1524 15.2724 13.4003C16.0246 12.6481 16.9175 12.0515 17.9003 11.6444C18.883 11.2373 19.9363 11.0278 21 11.0278C22.0637 11.0278 23.117 11.2373 24.0997 11.6444C25.0825 12.0515 25.9754 12.6481 26.7276 13.4003C27.4797 14.1524 28.0764 15.0454 28.4834 16.0281C28.8905 17.0108 29.1 18.0641 29.1 19.1278V25.3998H30V27.1998ZM14.7 25.3998H27.3V19.1278C27.3 17.457 26.6363 15.8545 25.4548 14.6731C24.2733 13.4916 22.6709 12.8278 21 12.8278C19.3291 12.8278 17.7267 13.4916 16.5452 14.6731C15.3637 15.8545 14.7 17.457 14.7 19.1278V25.3998ZM18.75 28.0998H23.25C23.25 28.3953 23.1918 28.6879 23.0787 28.9609C22.9657 29.2339 22.7999 29.4819 22.591 29.6908C22.3821 29.8998 22.134 30.0655 21.861 30.1786C21.5881 30.2916 21.2955 30.3498 21 30.3498C20.7045 30.3498 20.4119 30.2916 20.139 30.1786C19.866 30.0655 19.6179 29.8998 19.409 29.6908C19.2001 29.4819 19.0343 29.2339 18.9213 28.9609C18.8082 28.6879 18.75 28.3953 18.75 28.0998Z"
        fill="#B0B8C1"
      />
      <path
        className="nev-alert"
        d="M28.5 18C30.433 18 32 16.433 32 14.5C32 12.567 30.433 11 28.5 11C26.567 11 25 12.567 25 14.5C25 16.433 26.567 18 28.5 18Z"
        fill="#FF5151"
      />
    </svg>
  );
};

// nav icons
export const NavHomeIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6065 16.8063C17.6065 17.2483 17.2483 17.6065 16.8063 17.6065H4.00308C3.56115 17.6065 3.20288 17.2483 3.20288 16.8063V8.39545C3.20288 8.14851 3.31689 7.91541 3.51181 7.76381L9.91345 2.78477C10.2024 2.56002 10.607 2.56002 10.8959 2.78477L17.2975 7.76381C17.4925 7.91541 17.6065 8.14851 17.6065 8.39545V16.8063ZM16.0061 16.0061V8.78681L10.4047 4.43016L4.80328 8.78681V16.0061H16.0061Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavBuildingIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.20294 16.006V5.36372C3.20294 5.02722 3.41345 4.72668 3.72968 4.6117L11.4683 1.79763C11.676 1.72212 11.9055 1.82925 11.9811 2.03692C11.997 2.08075 12.0052 2.12702 12.0052 2.17365V6.1369L17.0594 7.82165C17.3862 7.93057 17.6066 8.23636 17.6066 8.58079V16.006H19.207V17.6064H1.60254V16.006H3.20294ZM4.80334 16.006H10.4048V3.88732L4.80334 5.9242V16.006ZM16.0062 16.006V9.15758L12.0052 7.82387V16.006H16.0062Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavSurvayIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4057 2.40283V4.00323H16.8116C17.2506 4.00323 17.6065 4.35928 17.6065 4.79816V17.6119C17.6065 18.0509 17.2505 18.4069 16.8116 18.4069H3.9978C3.55878 18.4069 3.20288 18.0508 3.20288 17.6119V4.79816C3.20288 4.35913 3.55893 4.00323 3.9978 4.00323H6.40369V2.40283H14.4057ZM6.40369 5.60364H4.80328V16.8065H16.0061V5.60364H14.4057V7.20404H6.40369V5.60364ZM8.00409 13.6057V15.2061H6.40369V13.6057H8.00409ZM8.00409 11.205V12.8055H6.40369V11.205H8.00409ZM8.00409 8.80444V10.4048H6.40369V8.80444H8.00409ZM12.8053 4.00323H8.00409V5.60364H12.8053V4.00323Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavShoppingIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00663 5.93687L1.41187 3.3421L2.54352 2.21045L5.13828 4.80521H17.3347C17.7767 4.80521 18.1349 5.16348 18.1349 5.60542C18.1349 5.68329 18.1236 5.76076 18.1013 5.83535L16.1808 12.237C16.0792 12.5755 15.7676 12.8073 15.4143 12.8073H5.60703V14.4077H14.4093V16.0081H4.80683C4.36489 16.0081 4.00663 15.6497 4.00663 15.2079V5.93687ZM5.60703 6.40562V11.2069H14.8189L16.2593 6.40562H5.60703ZM5.20693 19.2089C4.54402 19.2089 4.00663 18.6715 4.00663 18.0086C4.00663 17.3456 4.54402 16.8083 5.20693 16.8083C5.86984 16.8083 6.40724 17.3456 6.40724 18.0086C6.40724 18.6715 5.86984 19.2089 5.20693 19.2089ZM14.8094 19.2089C14.1464 19.2089 13.6091 18.6715 13.6091 18.0086C13.6091 17.3456 14.1464 16.8083 14.8094 16.8083C15.4723 16.8083 16.0097 17.3456 16.0097 18.0086C16.0097 18.6715 15.4723 19.2089 14.8094 19.2089Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavDraftIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8063 2.40283C17.2483 2.40283 17.6065 2.7611 17.6065 3.20303V6.20939L16.0061 7.80979V4.00323H4.80328V16.8065H16.0061V14.5995L17.6065 12.9991V17.6067C17.6065 18.0486 17.2483 18.4069 16.8063 18.4069H4.00308C3.56115 18.4069 3.20288 18.0486 3.20288 17.6067V3.20303C3.20288 2.7611 3.56115 2.40283 4.00308 2.40283H16.8063ZM18.2292 7.85029L19.3609 8.98193L13.1367 15.2061L12.0034 15.2044L12.0051 14.0744L18.2292 7.85029ZM11.2049 10.4048V12.0052H7.20389V10.4048H11.2049ZM13.6055 7.20404V8.80444H7.20389V7.20404H13.6055Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavMegaphoneIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.2038 13.6052C7.2038 13.6052 12.8052 14.4054 15.2058 16.806H16.006C16.448 16.806 16.8062 16.4477 16.8062 16.0058V11.1541C17.4965 10.9765 18.0065 10.3499 18.0065 9.60416C18.0065 8.85845 17.4965 8.23181 16.8062 8.05417V3.20255C16.8062 2.76061 16.448 2.40234 16.006 2.40234H15.2058C12.8052 4.80295 7.2038 5.60315 7.2038 5.60315H4.00299C3.11911 5.60315 2.40259 6.31967 2.40259 7.20355V12.0048C2.40259 12.8887 3.11911 13.6052 4.00299 13.6052H4.80319L5.60339 17.6062H7.2038V13.6052ZM8.8042 6.93244C9.35098 6.81513 10.0265 6.65296 10.7561 6.43834C12.099 6.04337 13.8055 5.4212 15.2058 4.46253V14.7458C13.8055 13.7871 12.099 13.165 10.7561 12.77C10.0265 12.5554 9.35098 12.3932 8.8042 12.2759V6.93244ZM4.00299 7.20355H7.2038V12.0048H4.00299V7.20355Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavHeadPhoneIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4066 14.4076C18.4058 16.7049 16.7915 18.625 14.6354 19.0963L14.1249 17.5647C15.0883 17.4075 15.9072 16.8201 16.378 16.0063H14.4056C13.5217 16.0063 12.8052 15.2898 12.8052 14.4059V11.205C12.8052 10.3211 13.5217 9.60464 14.4056 9.60464H16.7567C16.3629 6.4468 13.6691 4.00323 10.4046 4.00323C7.14008 4.00323 4.44629 6.4468 4.05252 9.60464H6.40359C7.28747 9.60464 8.004 10.3211 8.004 11.205V14.4059C8.004 15.2898 7.28747 16.0063 6.40359 16.0063H4.00299C3.11911 16.0063 2.40259 15.2898 2.40259 14.4059V10.4048C2.40259 5.98545 5.98521 2.40283 10.4046 2.40283C14.824 2.40283 18.4066 5.98545 18.4066 10.4048V11.204V11.205V14.4059V14.4076ZM16.8062 14.4059V11.205H14.4056V14.4059H16.8062ZM4.00299 11.205V14.4059H6.40359V11.205H4.00299Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavPushpinIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8668 2.15479L18.6568 8.94473L17.5251 10.0764L16.9593 9.51056L13.5643 12.9055L12.9985 15.7347L11.8668 16.8663L8.47184 13.4713L4.51106 17.4322L3.37939 16.3005L7.34019 12.3397L3.94522 8.94473L5.07688 7.81307L7.90602 7.24723L11.301 3.85227L10.7352 3.28645L11.8668 2.15479ZM12.4326 4.98393L8.69504 8.72153L6.43696 9.17311L11.6384 14.3746L12.09 12.1165L15.8276 8.3789L12.4326 4.98393Z"
        fill="#437BE6"
      />
    </svg>
  );
};
export const NavAlretIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4066 16.0062H2.40259V14.4058H3.20279V8.82948C3.20279 4.83814 6.42715 1.60254 10.4046 1.60254C14.3821 1.60254 17.6064 4.83814 17.6064 8.82948V14.4058H18.4066V16.0062ZM4.80319 14.4058H16.006V8.82948C16.006 5.72202 13.4982 3.20294 10.4046 3.20294C7.31103 3.20294 4.80319 5.72202 4.80319 8.82948V14.4058ZM8.4041 16.8064H12.4051C12.4051 17.9112 11.5094 18.8069 10.4046 18.8069C9.29976 18.8069 8.4041 17.9112 8.4041 16.8064Z"
        fill="#437BE6"
      />
    </svg>
  );
};

export const RightArrowIcon: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  );
};

export const CalanderIcon: React.FC = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1.4H13.3C13.4857 1.4 13.6637 1.47375 13.795 1.60503C13.9262 1.7363 14 1.91435 14 2.1V13.3C14 13.4857 13.9262 13.6637 13.795 13.795C13.6637 13.9262 13.4857 14 13.3 14H0.7C0.514349 14 0.336301 13.9262 0.205025 13.795C0.0737497 13.6637 0 13.4857 0 13.3V2.1C0 1.91435 0.0737497 1.7363 0.205025 1.60503C0.336301 1.47375 0.514349 1.4 0.7 1.4H3.5V0H4.9V1.4H9.1V0H10.5V1.4ZM1.4 5.6V12.6H12.6V5.6H1.4ZM2.8 8.4H6.3V11.2H2.8V8.4Z"
        fill="#6B7684"
      />
    </svg>
  );
};

export const TimeIcon: React.FC = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 14C5.61553 14 4.26216 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303298 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303298 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26216 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 12.6C8.10758 12.6 9.19028 12.2716 10.1112 11.6562C11.0321 11.0409 11.7499 10.1663 12.1737 9.14303C12.5976 8.11976 12.7085 6.99379 12.4924 5.9075C12.2763 4.8212 11.743 3.82338 10.9598 3.04021C10.1766 2.25703 9.1788 1.72368 8.09251 1.50761C7.00621 1.29153 5.88024 1.40243 4.85698 1.82628C3.83371 2.25013 2.95911 2.96789 2.34377 3.88881C1.72844 4.80973 1.4 5.89243 1.4 7C1.4 8.48522 1.99 9.9096 3.04021 10.9598C4.09041 12.01 5.51479 12.6 7 12.6ZM7.7 7H10.5V8.4H6.3V3.5H7.7V7Z"
        fill="white"
      />
    </svg>
  );
};

export const SearchIcon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#437BE6" />
      <path
        d="M20.5952 19.5175L23.8582 22.7805L22.7807 23.858L19.5177 20.595C18.3445 21.5336 16.8565 22.0951 15.2382 22.0951C11.4531 22.0951 8.3811 19.0231 8.3811 15.238C8.3811 11.4529 11.4531 8.38086 15.2382 8.38086C19.0234 8.38086 22.0954 11.4529 22.0954 15.238C22.0954 16.8563 21.5339 18.3442 20.5952 19.5175ZM19.0666 18.9521C19.9982 17.992 20.5716 16.6823 20.5716 15.238C20.5716 12.2913 18.1849 9.90467 15.2382 9.90467C12.2916 9.90467 9.90491 12.2913 9.90491 15.238C9.90491 18.1847 12.2916 20.5713 15.2382 20.5713C16.6825 20.5713 17.9922 19.998 18.9524 19.0663L19.0666 18.9521Z"
        fill="white"
      />
    </svg>
  );
};

export const SearchLineIcon: React.FC = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.207 24.959L30.007 28.753L28.753 30.007L24.959 26.207C23.3664 27.4805 21.3466 28.0958 19.3146 27.9264C17.2825 27.7571 15.3924 26.816 14.0326 25.2965C12.6728 23.7769 11.9466 21.7943 12.0031 19.756C12.0596 17.7176 12.8945 15.7783 14.3364 14.3364C15.7783 12.8945 17.7176 12.0596 19.756 12.0031C21.7943 11.9466 23.7769 12.6728 25.2965 14.0326C26.816 15.3924 27.7571 17.2825 27.9264 19.3146C28.0958 21.3466 27.4805 23.3664 26.207 24.959ZM24.43 24.302C25.5693 23.1276 26.1981 21.5505 26.1795 19.9144C26.1609 18.2783 25.4963 16.7159 24.3306 15.5677C23.1649 14.4196 21.5926 13.7788 19.9564 13.785C18.3202 13.7912 16.7528 14.4439 15.5959 15.6009C14.4389 16.7578 13.7862 18.3252 13.78 19.9614C13.7738 21.5976 14.4146 23.1699 15.5627 24.3356C16.7109 25.5013 18.2733 26.1659 19.9094 26.1845C21.5455 26.2031 23.1226 25.5743 24.297 24.435L24.43 24.302Z"
        fill="white"
      />
    </svg>
  );
};

export const XIcon: React.FC = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_210_3711"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="44"
        height="44"
      >
        <path d="M43.9999 0H0.0244141V44H43.9999V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_210_3711)">
        <path
          d="M22.0123 20.5862L26.9595 15.6362L28.3728 17.0502L23.4255 22.0002L28.3728 26.9502L26.9595 28.3642L22.0123 23.4142L17.0651 28.3642L15.6519 26.9502L20.5991 22.0002L15.6519 17.0502L17.0651 15.6362L22.0123 20.5862Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

export const Calendar: React.FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.3 0V1.8H11.7V0H13.5V1.8H17.1C17.3387 1.8 17.5676 1.89482 17.7364 2.0636C17.9052 2.23239 18 2.46131 18 2.7V17.1C18 17.3387 17.9052 17.5676 17.7364 17.7364C17.5676 17.9052 17.3387 18 17.1 18H0.9C0.661305 18 0.432387 17.9052 0.263604 17.7364C0.0948212 17.5676 0 17.3387 0 17.1V2.7C0 2.46131 0.0948212 2.23239 0.263604 2.0636C0.432387 1.89482 0.661305 1.8 0.9 1.8H4.5V0H6.3ZM16.2 9H1.8V16.2H16.2V9ZM4.5 3.6H1.8V7.2H16.2V3.6H13.5V5.4H11.7V3.6H6.3V5.4H4.5V3.6Z"
        fill="#6B7684"
      />
    </svg>
  );
};

export const NoticeIcon: React.FC = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill="white" />
      <path
        d="M18 26C18 26 25 27 28 30H29C29.5523 30 30 29.5523 30 29V22.937C30.8626 22.715 31.5 21.9319 31.5 21C31.5 20.0681 30.8626 19.285 30 19.063V13C30 12.4477 29.5523 12 29 12H28C25 15 18 16 18 16H14C12.8954 16 12 16.8954 12 18V24C12 25.1046 12.8954 26 14 26H15L16 31H18V26ZM20 17.6612C20.6833 17.5146 21.5275 17.3119 22.4393 17.0437C24.1175 16.5501 26.25 15.7726 28 14.5746V27.4254C26.25 26.2274 24.1175 25.4499 22.4393 24.9563C21.5275 24.6881 20.6833 24.4854 20 24.3388V17.6612ZM14 18H18V24H14V18Z"
        fill="#437BE6"
      />
    </svg>
  );
};

export const DownArrowIcon: React.FC = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.77489 3.87831L8.48724 0.166016L9.54788 1.22667L4.77489 5.99968L0.00195312 1.22667L1.06261 0.166016L4.77489 3.87831Z"
        fill="#6B7684"
      />
    </svg>
  );
};

export const RightArrowBigIcon: React.FC = () => {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1571 13.1437L9.16406 7.72248L10.5907 6.17358L17.0103 13.1437L10.5907 20.1136L9.16406 18.5648L14.1571 13.1437Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const CheckBoxBigGrayIcon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#E3E3E3" />
      <path
        d="M14.5453 18.3061L21.2307 11.6207L22.2592 12.6492L14.5453 20.3631L9.91699 15.7348L10.9455 14.7063L14.5453 18.3061Z"
        fill="white"
      />
    </svg>
  );
};

export const CheckBoxBigBlueIcon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="16" fill="#437BE6" />
      <path
        d="M14.5453 18.3061L21.2307 11.6207L22.2592 12.6492L14.5453 20.3631L9.91699 15.7348L10.9455 14.7063L14.5453 18.3061Z"
        fill="white"
      />
    </svg>
  );
};

export const DonwArrowIcon: React.FC = () => {
  return (
    <svg
      height="20"
      width="20"
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
  );
};

export const SettingIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.78288 14.1668C2.42267 13.5429 2.15231 12.8918 1.96777 12.2284C2.77817 11.8149 3.3331 10.9723 3.3331 10.0001C3.3331 9.02871 2.779 8.18662 1.96961 7.7728C2.34187 6.43038 3.04881 5.18018 4.05395 4.1583C4.81725 4.65342 5.82446 4.71274 6.66643 4.22662C7.50841 3.74051 7.96064 2.83858 7.9135 1.92999C9.30108 1.57046 10.7372 1.58332 12.0859 1.93214C12.0396 2.84001 12.4917 3.74089 13.3331 4.22662C14.1751 4.71272 15.1822 4.65342 15.9455 4.15835C16.4277 4.64984 16.8564 5.20955 17.2167 5.83347C17.5768 6.45737 17.8472 7.1085 18.0317 7.77186C17.2213 8.18535 16.6664 9.02796 16.6664 10.0001C16.6664 10.9716 17.2205 11.8136 18.0299 12.2275C17.6577 13.5699 16.9507 14.82 15.9456 15.842C15.1822 15.3469 14.1751 15.2875 13.3331 15.7736C12.4911 16.2597 12.0389 17.1617 12.086 18.0703C10.6985 18.4298 9.26233 18.417 7.91361 18.0681C7.95992 17.1602 7.50774 16.2594 6.66643 15.7736C5.82448 15.2875 4.81732 15.3468 4.05403 15.8419C3.57181 15.3504 3.1431 14.7907 2.78288 14.1668ZM7.49976 14.3303C8.40925 14.8554 9.06242 15.6855 9.37525 16.6382C9.7905 16.6777 10.2085 16.6783 10.6238 16.6395C10.9365 15.6864 11.5898 14.8556 12.4997 14.3303C13.4097 13.8049 14.4558 13.6545 15.4377 13.8603C15.6788 13.52 15.8873 13.1576 16.0607 12.7783C15.3922 12.031 14.9997 11.0503 14.9997 10.0001C14.9997 8.94996 15.3922 7.96929 16.0607 7.22204C15.974 7.03371 15.8782 6.84847 15.7732 6.6668C15.6683 6.48512 15.5558 6.30952 15.4361 6.14031C14.4547 6.34559 13.4092 6.19507 12.4997 5.67C11.5902 5.14492 10.9372 4.31469 10.6242 3.36208C10.2091 3.32257 9.791 3.32201 9.37575 3.36072C9.063 4.31388 8.40966 5.14466 7.49976 5.67C6.58983 6.19535 5.54371 6.34574 4.5619 6.13998C4.32071 6.4803 4.11219 6.8426 3.9388 7.22193C4.60734 7.96922 4.99977 8.94996 4.99977 10.0001C4.99977 11.0503 4.60736 12.031 3.9388 12.7782C4.02556 12.9665 4.12136 13.1518 4.22626 13.3335C4.33116 13.5151 4.44367 13.6907 4.56343 13.86C5.54481 13.6547 6.59031 13.8052 7.49976 14.3303ZM9.99975 12.5001C8.61908 12.5001 7.49976 11.3809 7.49976 10.0001C7.49976 8.61946 8.61908 7.50013 9.99975 7.50013C11.3805 7.50013 12.4997 8.61946 12.4997 10.0001C12.4997 11.3809 11.3805 12.5001 9.99975 12.5001ZM9.99975 10.8335C10.46 10.8335 10.8331 10.4604 10.8331 10.0001C10.8331 9.53987 10.46 9.16679 9.99975 9.16679C9.5395 9.16679 9.16641 9.53987 9.16641 10.0001C9.16641 10.4604 9.5395 10.8335 9.99975 10.8335Z"
        fill="#B0B8C1"
      />
    </svg>
  );
};

export const AddFill: React.FC = () => {
  return (
    <svg
      width="37"
      height="36"
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0283 16.5V7.5H20.0283V16.5H29.0283V19.5H20.0283V28.5H17.0283V19.5H8.02832V16.5H17.0283Z"
        fill="white"
      />
    </svg>
  );
};

export const TimeLine: React.FC = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0002 20.1668C5.93755 20.1668 1.8335 16.0627 1.8335 11.0002C1.8335 5.93755 5.93755 1.8335 11.0002 1.8335C16.0627 1.8335 20.1668 5.93755 20.1668 11.0002C20.1668 16.0627 16.0627 20.1668 11.0002 20.1668ZM11.0002 18.3335C15.0503 18.3335 18.3335 15.0503 18.3335 11.0002C18.3335 6.95007 15.0503 3.66683 11.0002 3.66683C6.95007 3.66683 3.66683 6.95007 3.66683 11.0002C3.66683 15.0503 6.95007 18.3335 11.0002 18.3335ZM11.9168 11.0002H15.5835V12.8335H10.0835V6.41683H11.9168V11.0002Z"
        fill="#D7DBDE"
      />
    </svg>
  );
};

export const AlertViewIcon: React.FC = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#4E5565" />
      <path
        d="M14.7621 13.3334H5.23828V12.381H5.71447V9.06263C5.71447 6.68743 7.63325 4.76196 10.0002 4.76196C12.3671 4.76196 14.2859 6.68743 14.2859 9.06263V12.381H14.7621V13.3334ZM8.80971 13.8096H11.1907C11.1907 14.4671 10.6577 15.0001 10.0002 15.0001C9.34271 15.0001 8.80971 14.4671 8.80971 13.8096Z"
        fill="white"
      />
    </svg>
  );
};

export const StarGray: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00007 12.1733L3.29777 14.8054L4.34799 9.51985L0.391602 5.86112L5.74296 5.22663L8.00007 0.333252L10.2571 5.22663L15.6085 5.86112L11.6521 9.51985L12.7023 14.8054L8.00007 12.1733Z"
        fill="#E0E0E0"
      />
    </svg>
  );
};

export const StarYellow: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00007 12.1733L3.29777 14.8054L4.34799 9.51985L0.391602 5.86112L5.74296 5.22663L8.00007 0.333252L10.2571 5.22663L15.6085 5.86112L11.6521 9.51985L12.7023 14.8054L8.00007 12.1733Z"
        fill="#FFD056"
      />
    </svg>
  );
};
